export const getCurrentBasePath = (): string => {
    const pathParts = window.location.pathname.split('/').filter(Boolean);
    return pathParts[0] || '';
};
